export default __webpack_public_path__ + "static/media/vingt.08698223.png";